<svelte:options accessors/>
<script lang="ts">
    import type {IMaintenancePrice} from "../../data";
    import {getFormatter, getSelectedCity} from "../../utils";
    import {onMount} from "svelte";
    import {Cart, getCart} from "../../models/cart";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let loading: boolean = true;
    export let show: boolean = false;
    export let price: IMaintenancePrice;
    export let data: any;
    export let km: number;
    export let cart: Cart;

    const formatter = getFormatter();

    export let dialog: any = {
        open: false,
        message: ''
    }

    onMount(() => {
        getCart().then((c) => {
            cart = c;
        });
    })

    export function setFlag() {
        const container = document.getElementById('flag-container');
        if (container && price?.porcDescuento > 0) {
            const div = document.createElement('div');
            div.setAttribute('class', 'discount-flag absolute')
            div.textContent = `DCTO ${price.porcDescuento}%`
            container.textContent = '';
            container.appendChild(div);
        }
    }

    function add() {
        const selectedCity = getSelectedCity();
        const plan = {
            item: {
                reference: data.id,
                vin: price.vin,
                codModeloTasa: price.codModeloTasa,
                image: data.image,
                type: 'S',
                name: data.title,
                km,
                route: `${location.pathname}`
            },
            quantity: 1,
            price: price.precioNeto,
            prevPrice: price.precioTotal,
            flag: price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
            city: {
                id: selectedCity
            }
        };
        cart.addPlan(plan);
        cart.update().then(() => {
            dialog.open = true;
            dialog.message = 'El plan ha sido agregado al carrito';
        }).catch(() => {
            dialog.open = true;
            dialog.message = 'Se presento un error agregando el plan al carrito';
        });
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }
</script>
{#if show}
    <div class="text-c mb-1 m:text-l m:mt-2">
        {#if loading}
            Consultando precio...
        {:else if price}
            {#if price.porcDescuento > 0}
                <small>Antes {formatter(price.precioTotal)}</small>
            {/if}
            <div class="price">
                {formatter(price.precioNeto)}
            </div>
            <div class="btn accent" on:click={()=>add()}>
                AGREGAR
            </div>
        {:else}
            NO DISPONIBLE
        {/if}
    </div>
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>